// chakra imports
import { Icon, Flex, Text, useColorModeValue, MenuItem } from "@chakra-ui/react";
import * as md from 'react-icons/md'
import { Notification } from "api/types";
import { ApiNotificationDownload } from "api/notifications/notifications";
import { useLoading } from "contexts/LoadingContext";

export function ItemContent(props: { notification: Notification }) {
  const textColor = useColorModeValue("navy.700", "white");
  let mdIcons = md
  const { notification } = props
  const { show, hide } = useLoading()
  const handleAttachmentDownload = async (event: any = null) => {
    show()
      ApiNotificationDownload(notification.id).then(response => {
        const url = URL.createObjectURL(response.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = notification.downloadableFileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        hide()
      })
  }
   return (
    <>
      <MenuItem _hover={{ bg: 'none' }} _focus={{ bg: 'none' }} px='0' borderRadius='8px' mb='10px' pr="10px">
        <Flex
          justify='center'
          align='center'
          borderRadius='16px'
          minH={{ base: "60px", md: "70px" }}
          h={{ base: "60px", md: "70px" }}
          minW={{ base: "60px", md: "70px" }}
          w={{ base: "60px", md: "70px" }}
          me='14px'
          bg='linear-gradient(135deg, #868CFF 0%, #4318FF 100%)'>
          <Icon as={eval(notification.icon)} color='white' w={8} h={14} onClick={notification.hasAttachment?handleAttachmentDownload:null}/>
        </Flex>
        <Flex flexDirection='column'>
          <Text
            mb='5px'
            fontWeight='bold'
            color={textColor}
            fontSize={{ base: "sm", "2xl": "md" }}
            lineHeight={{ base: "short" }}>
            {notification.title + ' (' + notification.createdAt.toLocaleDateString() + ')'}
          </Text>
          <Flex alignItems='center'>
            <Text
              fontSize={{ base: "sm", md: "sm" }}
              lineHeight='100%'
              color={textColor}>
              {notification.description}
            </Text>
          </Flex>
        </Flex>
      </MenuItem>
    </>
  );
}
